import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { compact, includes } from 'lodash';
import ReactIcon from '../../Icons';
import { offersLengthByPlatform } from '../utils';
import { OFFERS_PLATFORMS } from '../../../constants';

const baseIcon = { color: '#22252a', size: 13, marginBottom: '3px' };
const androidIcon = ReactIcon({ ...baseIcon, type: 'android' });
const iPadIcon = ReactIcon({ ...baseIcon, type: 'ipad' });
const iPhoneIcon = ReactIcon({ ...baseIcon, type: 'iphone' });
const webIcon = ReactIcon({ ...baseIcon, type: 'web' });

const baseSelectedIcon = { color: '#0e68f9', size: 13, marginBottom: '3px' };
const androidSelectedIcon = ReactIcon({ ...baseSelectedIcon, type: 'android' });
const iPadSelectedIcon = ReactIcon({ ...baseSelectedIcon, type: 'ipad' });
const iPhoneSelectedIcon = ReactIcon({ ...baseSelectedIcon, type: 'iphone' });
const webSelectedIcon = ReactIcon({ ...baseSelectedIcon, type: 'web' });

export default function OfferDeviceCategories({
  offers = [],
  savedDevices = [],
  selected,
  onSelect,
  onChange,
}) {
  const { getText } = Pollfish.ui;
  const web = useMemo(
    () => offersLengthByPlatform(offers, OFFERS_PLATFORMS.WEB).length,
    [offers],
  );
  const android = useMemo(
    () => offersLengthByPlatform(offers, OFFERS_PLATFORMS.ANDROID).length,
    [offers],
  );
  const iPad = useMemo(
    () => offersLengthByPlatform(offers, OFFERS_PLATFORMS.I_PAD).length,
    [offers],
  );
  const iPhone = useMemo(
    () => offersLengthByPlatform(offers, OFFERS_PLATFORMS.I_PHONE).length,
    [offers],
  );

  const showAndroid = includes(savedDevices, OFFERS_PLATFORMS.ANDROID);
  const showIPad = includes(savedDevices, OFFERS_PLATFORMS.I_PAD);
  const showIPhone = includes(savedDevices, OFFERS_PLATFORMS.I_PHONE);
  const showAll = compact([showAndroid, showIPad, showIPhone]).length > 0;

  return (
    <section className="container offerwall-offer-categories">
      {showAll && (
        <button
          type="button"
          className={`reset-button offerwall-offer-categories-btn ${
            selected === OFFERS_PLATFORMS.ALL
              ? 'offerwall-offer-categories-btn-selected'
              : ''
          }`}
          onClick={() => onSelect(OFFERS_PLATFORMS.ALL)}
          data-testid="offer-device-all"
        >
          {getText('offerwall.filters.all')} ({offers.length})
        </button>
      )}
      <button
        type="button"
        className={`reset-button offerwall-offer-categories-btn ${
          selected === OFFERS_PLATFORMS.WEB
            ? 'offerwall-offer-categories-btn-selected'
            : ''
        }`}
        onClick={() => onSelect(OFFERS_PLATFORMS.WEB)}
        data-testid="offer-device-web"
      >
        {selected === OFFERS_PLATFORMS.WEB ? webSelectedIcon : webIcon}
        Web ({web})
      </button>
      {showAndroid && (
        <button
          type="button"
          className={`reset-button offerwall-offer-categories-btn ${
            selected === OFFERS_PLATFORMS.ANDROID
              ? 'offerwall-offer-categories-btn-selected'
              : ''
          }`}
          onClick={() => onSelect(OFFERS_PLATFORMS.ANDROID)}
          data-testid="offer-device-android"
        >
          {selected === OFFERS_PLATFORMS.ANDROID
            ? androidSelectedIcon
            : androidIcon}
          Android ({android})
        </button>
      )}
      {showIPhone && (
        <button
          type="button"
          className={`reset-button offerwall-offer-categories-btn ${
            selected === OFFERS_PLATFORMS.I_PHONE
              ? 'offerwall-offer-categories-btn-selected'
              : ''
          }`}
          onClick={() => onSelect(OFFERS_PLATFORMS.I_PHONE)}
          data-testid="offer-device-iphone"
        >
          {selected === OFFERS_PLATFORMS.I_PHONE
            ? iPhoneSelectedIcon
            : iPhoneIcon}
          iPhone ({iPhone})
        </button>
      )}
      {showIPad && (
        <button
          type="button"
          className={`reset-button offerwall-offer-categories-btn ${
            selected === OFFERS_PLATFORMS.I_PAD
              ? 'offerwall-offer-categories-btn-selected'
              : ''
          }`}
          onClick={() => onSelect(OFFERS_PLATFORMS.I_PAD)}
          data-testid="offer-device-ipad"
        >
          {selected === OFFERS_PLATFORMS.I_PAD ? iPadSelectedIcon : iPadIcon}
          iPad ({iPad})
        </button>
      )}
      <button
        type="button"
        className="reset-button offerwall-offer-categories-change"
        onClick={onChange}
        data-testid="offer-change-device"
      >
        {getText('offerwall.offers.deviceTypes.change')}
      </button>
    </section>
  );
}

OfferDeviceCategories.propTypes = {
  selected: PropTypes.string,
  offers: PropTypes.array,
  savedDevices: PropTypes.array,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
};
